module.exports = __webpack_public_path__ + "img/14.b1caf442.jpg";